var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(
      ( Object.keys(_vm.userinfo).length > 0
      && _vm.configLang
      )
      ||
      _vm.tokenFreePages.includes(_vm.$route.path)
  )?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }